import { HttpErrorResponse } from '@angular/common/http';

export function retrieveErrorMessage(error: Error | HttpErrorResponse | ErrorEvent): string {
  if ('error' in error) {
    return error.error.message;
  }
  return error.message;
}

export function retrieveErrorStatusCode(
  error: Error | HttpErrorResponse | ErrorEvent
): string | undefined {
  if ('error' in error) {
    return error.error.status;
  }
  return undefined;
}
